import AdaptiveImage from "../../../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js";

export default new AdaptiveImage({
    uri: __webpack_public_path__ + "f5dfe586511b50acdc97adfb9a588d4d.jpg","uri@2x": __webpack_public_path__ + "b07f780e398dcbeb163443aa7fa80cba.jpg","uri@3x": __webpack_public_path__ + "c9840ae71d0ae2e0c07df95b99396de6.jpg",
    width: 320,
    height: 568
});